const windowUtils = {
  reload: () => {
    window.location.reload();
  },
  location: () => {
    return window.location;
  },
  segment: () => {
    return window.SrAnalytics;
  }
};

export default windowUtils;
